var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretRegularRight = function SvgCaretRegularRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.195 7.26c.407.409.407 1.07 0 1.474l-6.923 6.96a1.03 1.03 0 0 1-1.467 0 1.047 1.047 0 0 1 0-1.475l6.188-6.22-6.188-6.22a1.043 1.043 0 0 1 0-1.474 1.034 1.034 0 0 1 1.467 0l6.923 6.96z"
  })));
};
export default SvgCaretRegularRight;